"use strict";
var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __getOwnPropNames = Object.getOwnPropertyNames;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __export = (target, all) => {
  for (var name in all)
    __defProp(target, name, { get: all[name], enumerable: true });
};
var __copyProps = (to, from, except, desc) => {
  if (from && typeof from === "object" || typeof from === "function") {
    for (let key of __getOwnPropNames(from))
      if (!__hasOwnProp.call(to, key) && key !== except)
        __defProp(to, key, { get: () => from[key], enumerable: !(desc = __getOwnPropDesc(from, key)) || desc.enumerable });
  }
  return to;
};
var __toCommonJS = (mod) => __copyProps(__defProp({}, "__esModule", { value: true }), mod);
var KnownWorkspaceFeatureEnum_generated_exports = {};
__export(KnownWorkspaceFeatureEnum_generated_exports, {
  KnownWorkspaceFeatureEnum: () => KnownWorkspaceFeatureEnum
});
module.exports = __toCommonJS(KnownWorkspaceFeatureEnum_generated_exports);
var import_util = require("@cartographerio/util");
const EnableMobile = "EnableMobile";
const OfflineMaps = "OfflineMaps";
const EnableArcgisIntegration = "EnableArcgisIntegration";
const EnableInvitationCodes = "EnableInvitationCodes";
const EnableTeams = "EnableTeams";
const PreferTeams = "PreferTeams";
const LockAlias = "LockAlias";
const KnownWorkspaceFeatureEnum = {
  ...(0, import_util.createEnum)("KnownWorkspaceFeature", [
    [EnableMobile, "Enable mobile app (standard feature)"],
    [OfflineMaps, "Enable offline maps on mobile (plus feature)"],
    [EnableArcgisIntegration, "Enable ArcGIS Online integration (plus feature)"],
    [EnableInvitationCodes, "Enable invitation codes (plus feature)"],
    [EnableTeams, "Enable teams (premium feature)"],
    [PreferTeams, "Prefer teams in the UI (premium feature)"],
    [LockAlias, "Lock workspace alias (prevent editing)"]
  ]),
  EnableMobile,
  OfflineMaps,
  EnableArcgisIntegration,
  EnableInvitationCodes,
  EnableTeams,
  PreferTeams,
  LockAlias
};
null;
null;
// Annotate the CommonJS export names for ESM import in node:
0 && (module.exports = {
  KnownWorkspaceFeatureEnum
});
//# sourceMappingURL=KnownWorkspaceFeatureEnum.generated.js.map
